import {
    NEWSOVERVIEW_RECEIVE,
    NEWSOVERVIEW_ERROR,
    NEWSOVERVIEW_CHANGE_MODE,
    NEWSOVERVIEW_CHANGE_CURRENTPAGE,
    ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    newsOverView: {},
    totalCount: 0,
    errors: {},
    title: '',
    description: ''
};

export const newsOverView = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case NEWSOVERVIEW_RECEIVE:
        case NEWSOVERVIEW_CHANGE_MODE:
        case NEWSOVERVIEW_CHANGE_CURRENTPAGE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case NEWSOVERVIEW_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
